import { resultsDuckCreator } from 'axl-ducks';
import { pageNames } from '@atc/bonnet-paths';

export default resultsDuckCreator({
    namespace: pageNames.DEALER_SEARCH,
    store: 'dealerLotResults',
    storePrefix: `${pageNames.DEALER_SEARCH}.`,
});
